import { Stack } from "@mui/material";
import { FormCategory } from "@simplyk/common";

import { FormChip } from "@/forms-design-system/FormChip";
import { useTranslate } from "@/hooks/useTranslate";

type ThemedPeerCredibilityChipTicketsLeftProps = {
  remainingTickets: number;
  formCategory: FormCategory;
};

export const ThemedPeerCredibilityChipTicketsLeft = ({
  remainingTickets,
  formCategory,
  ...rest
}: ThemedPeerCredibilityChipTicketsLeftProps) => {
  const { t } = useTranslate();

  if (remainingTickets >= 20 || remainingTickets === Infinity) {
    return null;
  }

  const chipLabel =
    formCategory === FormCategory.Event
      ? t("ticketing", "peerCredibilityChip.remainingTickets", { remainingTickets })
      : formCategory === FormCategory.Shop
        ? t("ticketing", "peerCredibilityChip.remainingItems", { remainingTickets })
        : formCategory === FormCategory.MembershipV2
          ? t("ticketing", "peerCredibilityChip.remainingMemberships", { remainingTickets })
          : null;

  if (!chipLabel) {
    return null;
  }

  return (
    <Stack direction="row" spacing={1}>
      <FormChip vibe="neutral" variant="outlined" label={chipLabel} {...rest} />
    </Stack>
  );
};
